import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, DialogConfirm } from 'components'
import { toast } from 'react-toastify'
import { TextField } from '@mui/material'
import { cloneDeep } from 'lodash'
import AddAttachments from 'components/AddAttachments'

import { removeAttachment } from 'utils/attachmentOperations'
import { useSelector } from 'react-redux'
import { submitExtraAutoAnswer } from 'services/apiKYP'

import styles from './styles'

const initialValues = {
  process_object: '',
  process_status: '',
  attachments: [],
  legal_advice: '',
  answer_type: 'processes',
}

const initialErrors = {
  process_object: false,
  process_status: false,
  attachments: false,
}

function ProcessesForm(props) {
  const { questionData } = props

  const token = useSelector((state) => state.auth.access_token)
  const classes = styles()

  const [formState, setFormState] = useState(initialValues)
  const [formErrors, setFormErrors] = useState(initialErrors)
  const [loading, setLoading] = useState(false)
  const [open, setOpen] = useState(false)
  
  const handleValidate = () => {
    const errors = cloneDeep(initialErrors)
    Object.keys(errors).forEach((key) => {
      errors[key] = formState[key] === '' || formState[key]?.length === 0
    })
    setFormErrors(errors)
    return Object.keys(errors).every((key) => errors[key] === false)
  }

  const cleanForm = () => {
    setFormState(initialValues)
    setFormErrors(initialErrors)
  }

  const handleSubmit = async () => {
    if (handleValidate()) {
      setLoading(true)
      submitExtraAutoAnswer(token, questionData.uuid, formState)
        .then(() => {
          toast.success('Resposta enviada com sucesso')
          cleanForm()
        })
        .catch(() => {
          toast.error('Erro ao enviar respostas, por favor tente novamente')
        })
        .finally(() => {
          setLoading(false)
        })
    } else {
      toast.error(
        'Há campos obrigatórios vazios. Verifique os campos preenchidos e tente novamente.',
      )
    }
  }

  const handleCleanAction = () => {
    setOpen(false)
    const attachments = cloneDeep(formState.attachments)
    if (attachments.length > 0) {
      Promise.all(
        attachments.map((attachment) =>
          removeAttachment(attachment.uuid, token),
        ),
      )
    }
    setFormState(initialValues)
    setFormErrors(initialErrors)
  }

  const handleFieldChange = (event) => {
    const newFormState = cloneDeep(formState)
    const key = event.target.id
    newFormState[key] = event.target.value
    setFormState(newFormState)
  }

  const handleUpdateAttachments = (attachmentsList) => {
    const newFormState = cloneDeep(formState)
    newFormState.attachments = attachmentsList
    setFormState(newFormState)
  }

  const handleOpenConfirmCleaning = () => {
    setOpen(true)
  }
  
  const handleCloseConfirmCleaning = () => {
    setOpen(false)
  }
  
  return (
    <div className={classes.root}>
      <h2>Processo n° {questionData.occurrence.number}</h2>
      <div className={classes.formWrapper}>
        <TextField
          id="process_object"
          label="Objeto do processo"
          onChange={handleFieldChange}
          required
          fullWidth
          value={formState.process_object}
          InputLabelProps={{ shrink: true }}
          error={formErrors.process_object}
          size="small"
        />
        <TextField
          id="process_status"
          label="Status atual do processo"
          onChange={handleFieldChange}
          required
          fullWidth
          value={formState.process_status}
          InputLabelProps={{ shrink: true }}
          error={formErrors.process_status}
          size="small"
        />
        <AddAttachments
          attachments={formState.attachments}
          updateAttachments={handleUpdateAttachments}
          error={formErrors.attachments}
          title="Principais peças do caso do processo (ex. principais decisões)"
        />
        <TextField
          id="legal_advice"
          label="Se possível, parecer do advogado que acompanhou o processo"
          onChange={handleFieldChange}
          fullWidth
          multiline
          minRows={4}
          value={formState.legal_advice}
          InputLabelProps={{ shrink: true }}
          size="small"
        />
        <div className={classes.buttonsContainer}>
          <Button onClick={handleOpenConfirmCleaning} variant="text">
            Limpar formulário
          </Button>
          <Button onClick={handleSubmit} loading={loading}>
            Responder
          </Button>
        </div>
      </div>
      <DialogConfirm 
        title='Tem certeza de que deseja limpar este formulário?'
        onConfirm={handleCleanAction}
        onCancel={handleCloseConfirmCleaning}
        open={open}
      >
        Esta ação é irreversível e não poderá ser desfeita.
      </DialogConfirm>
    </div>
  )
}

ProcessesForm.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default ProcessesForm
